import React, { Suspense } from "react";
import type { PanelEntry } from "@/v2/stores/panelStore";
import { Skeleton } from "@/v2/ui/primitives/skeleton";

const VehiclePanelView = React.lazy(() => import("./views/VehiclePanelView"));
const RentalPanelView = React.lazy(() => import("./views/RentalPanelView"));
const StationPanelView = React.lazy(() => import("./views/StationPanelView"));
const DockPanelView = React.lazy(() => import("./views/DockPanelView"));
const UserPanelView = React.lazy(() => import("./views/UserPanelView"));
const ReservationPanelView = React.lazy(
  () => import("./views/ReservationPanelView")
);
const TransactionPanelView = React.lazy(
  () => import("./views/TransactionPanelView")
);
const CityPanelView = React.lazy(() => import("./views/CityPanelView"));
const LockPanelView = React.lazy(() => import("./views/LockPanelView"));
const VehicleModelPanelView = React.lazy(
  () => import("./views/VehicleModelPanelView")
);
const AttentionPanelView = React.lazy(
  () =>
    import("@/v2/containers/overviewContainer/components/AttentionPanelView")
);

function PanelSkeleton() {
  return (
    <div className="tw-space-y-4 tw-p-4">
      <Skeleton className="tw-h-5 tw-w-2/3" />
      <Skeleton className="tw-h-4 tw-w-1/2" />
      <Skeleton className="tw-h-4 tw-w-3/4" />
      <Skeleton className="tw-h-4 tw-w-1/2" />
      <Skeleton className="tw-h-4 tw-w-2/3" />
      <Skeleton className="tw-h-4 tw-w-1/3" />
    </div>
  );
}

interface EntityPanelRouterProps {
  entry: PanelEntry;
}

export function EntityPanelRouter({ entry }: EntityPanelRouterProps) {
  return <Suspense fallback={<PanelSkeleton />}>{renderView(entry)}</Suspense>;
}

function renderView(entry: PanelEntry) {
  switch (entry.entityType) {
    case "vehicle":
      return <VehiclePanelView entityId={entry.entityId} />;
    case "rental":
      return <RentalPanelView entityId={entry.entityId} />;
    case "station":
      return <StationPanelView entityId={entry.entityId} />;
    case "dock":
      return <DockPanelView entityId={entry.entityId} />;
    case "user":
      return <UserPanelView entityId={entry.entityId} />;
    case "reservation":
      return <ReservationPanelView entityId={entry.entityId} />;
    case "transaction":
      return <TransactionPanelView entityId={entry.entityId} />;
    case "city":
      return <CityPanelView entityId={entry.entityId} />;
    case "vehicleModel":
      return <VehicleModelPanelView entityId={entry.entityId} />;
    case "lock":
      return <LockPanelView entityId={entry.entityId} />;
    case "attention":
      return <AttentionPanelView entry={entry} />;
    default:
      return null;
  }
}
